package one.devsbox.www.provider

import androidx.compose.animation.AnimatedVisibility
import androidx.compose.animation.fadeIn
import androidx.compose.animation.fadeOut
import androidx.compose.foundation.layout.Box
import androidx.compose.foundation.layout.BoxScope
import androidx.compose.foundation.layout.fillMaxSize
import androidx.compose.runtime.*
import androidx.compose.ui.Modifier

@Suppress("unused")
val LocalOverlayProvider =
    staticCompositionLocalOf<OverlayProvider> { error("OverlayProvider is not implemented by CompositionLocalProvider") }

class ImplOverlayProvider : OverlayProvider {


    private val overlays = mutableStateListOf<OverlayProvider.OverlayState>()

    @Composable
    override fun attach(state: OverlayProvider.OverlayState) {
        DisposableEffect(Unit) {
            overlays += state
            onDispose {
                overlays -= state
            }
        }
    }

    @Composable
    fun bind() {
        overlays.forEach { entry ->
            AnimatedVisibility(entry.visible, enter = fadeIn(), exit = fadeOut()) {
                Box(Modifier.fillMaxSize()) {
                    entry.body(this, object : OverlayProvider.Visibility {
                        override fun show() {
                            entry.visible = true
                        }

                        override fun hide() {
                            entry.visible = false
                        }

                    })
                }
            }
        }
    }

}

interface OverlayProvider {
    @Stable
    class OverlayState private constructor(
        show: Boolean = false,
        val body: @Composable BoxScope.(Visibility) -> Unit = {}
    ) : Visibility {
        var visible by mutableStateOf(show)

        override fun show() {
            visible = true
        }

        override fun hide() {
            visible = true
        }

        companion object {
            @Composable
            fun rememberState(show: Boolean = false, body: @Composable BoxScope.(Visibility) -> Unit = {}) = remember {
                OverlayState(show, body)
            }
        }

    }

    interface Visibility {
        fun show()
        fun hide()
    }

    @Composable
    fun attach(state: OverlayState)
}